import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { IAdProduct } from "../../whatsappAdProducts.types";
import { requestUpdateAdProduct } from "./updateAdProduct.request";

const useUpdateAdProduct = (
  options?: MutationOptions<IAdProduct, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateAdProduct,
    ...options
  });
};

export default useUpdateAdProduct;
